import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { AccountFacade } from '@mode/accounts/contract';
import { DatasourceFacade, WorkspaceCollectionFacade } from '@mode/accounts/domain';

export const DowngradedAccountsDomainModule = angular
  .module('downgraded-accounts-domain', [])
  .service('AccountFacade', downgradeInjectable(AccountFacade))
  .service('DatasourceFacade', downgradeInjectable(DatasourceFacade))
  .service('WorkspaceCollectionFacade', downgradeInjectable(WorkspaceCollectionFacade)).name;
